import { useLayoutEffect, useState, useRef } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  container: {
    width: 516,
    background: theme.colorDarkGrey,
    position: "absolute",
    zIndex: 1000,
    boxShadow: "2px 0px 16px rgba(0, 0, 0, 0.27)",
    "border-radius": 3,
    left: "calc( 50% - 328px)",
    top: "8vh",
    padding: "41px 70px",
    color: "white",
    overflow: "auto",
    animation: "$fadein ease 0.2s",
    "& h2": {
      color: theme.colorSecondary,
      marginTop: 0,
    },
    "& button": {
      background: "#575757",
      color: "white",
      outline: "none",
      border: "none",
      "border-radius": 3,
      padding: "4px 15px",
      marginLeft: 15,
      cursor: "pointer",
    },
    "& p": {
      color: "#9e9e9e",
    },
  },
  backgroundHider: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 10,
  },
  buttons: {
    marginTop: 15,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  copyArea: {
    resize: "none",
    padding: 5,
    width: "calc(100% - 10px)",
  },
}));

const EmbedModel = ({ toggleEmbedPopup, url }) => {
  const [height, setHeight] = useState(1);
  const classes = useStyles();
  const copyRef = useRef();

  const copySnippet = () => {
    if (copyRef.current) {
      copyRef.current.select();
      document.execCommand("copy");
    }
  };

  useLayoutEffect(() => {
    if (copyRef) {
      copyRef.current.select();
      // -10 for the padding
      setHeight(copyRef.current.scrollHeight - 10);
    }
  }, []);

  return (
    <>
      <div className={classes.container}>
        <h2>Embed Tour</h2>
        <p>Copy the snippet below and paste it into your website's HTML code</p>
        <textarea
          ref={copyRef}
          readOnly
          style={{ height }}
          className={classes.copyArea}
          value={`<iframe src="${url}" width="100%" height="100%" frameBorder="0" style="border-width:0; min-height:40vh" allow="gyroscope; accelerometer" allowfullscreen></iframe>`}
        />
        <div className={classes.buttons}>
          <button onClick={copySnippet}>Copy Snippet</button>
          <button onClick={toggleEmbedPopup}>Close</button>
        </div>
      </div>
      <div className={classes.backgroundHider} onClick={toggleEmbedPopup} />
    </>
  );
};

export default EmbedModel;
